export const TYPE_REQUEST_TENANTS = 'tenants/REQUEST_TENANTS';
export const TYPE_RECEIVE_TENANTS = 'tenants/RECEIVE_TENANTS';
